import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { configSectionsInOut } from 'animations-lib';
import { FieldConfigChangedControllerService } from '../../../data-fields/field-config-changed-controller.service';

@Component({
    selector: 'app-limit',
    templateUrl: './limit.component.html',
    styles: ['input[type="number"] { width: 78px; }'],
    styleUrls: ['../field-options.component.scss'],
    animations: [configSectionsInOut],
    standalone: false
})
export class LimitComponent implements OnInit {
  @Input() set fieldOptions(limit: number | undefined) {
    this.initFieldOptions(limit);
    this.hasChanged = false;
  }
  @Output() fieldOptionsChange = new EventEmitter<number>();

  expanded = false;
  limit: number | undefined;
  hasChanged = false;

  constructor(private configChangedControllerService: FieldConfigChangedControllerService) {}

  ngOnInit() {
    this.hasChanged = this.configChangedControllerService.get('LimitComponent');
  }

  updateParent() {
    this.fieldOptionsChange.emit(this.limit);
    this.configChangedControllerService.update('LimitComponent', true);
    setTimeout(() => (this.hasChanged = true), 0);
  }

  toggleExpanded() {
    this.expanded = !this.expanded;
  }

  private initFieldOptions(limit: number | undefined) {
    this.limit = limit;
  }
}
